<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  items: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['add', 'close']);

const { t } = useI18n();

const onAddClick = () => {
  emit('add');
};

const onClickClose = () => {
  emit('close');
};
</script>

<template>
  <div
    class="flex flex-col items-start self-stretch rounded-2xl w-full overflow-hidden border border-slate-200 bg-white"
  >
    <div
      class="flex items-center justify-between w-full gap-3 px-5 py-4 border-b border-slate-200 bg-white"
    >
      <div class="flex items-center gap-3 min-w-0">
        <div
          class="w-9 h-9 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center text-slate-900 flex-shrink-0"
        >
          <span class="i-lucide-sparkles size-4" />
        </div>
        <div class="min-w-0">
          <h5 class="text-sm font-semibold text-slate-900 m-0 truncate">
            {{ title }}
          </h5>
        </div>
        <Button
          :label="t('AILAB.ASSISTANTS.GUARDRAILS.ADD.SUGGESTED.ADD')"
          variant="outline"
          color="slate"
          size="xs"
          class="flex-shrink-0"
          @click="onAddClick"
        />
      </div>
      <Button
        variant="ghost"
        color="slate"
        size="xs"
        icon="i-lucide-x"
        class="flex-shrink-0"
        @click="onClickClose"
      />
    </div>
    <div class="flex flex-col items-start divide-y divide-slate-200 w-full">
      <div v-for="item in items" :key="item.content" class="w-full px-5 py-4">
        <slot :item="item" />
      </div>
    </div>
  </div>
</template>
